import { writable } from "svelte/store";
import type { LimitedOrderingProductRequest } from "@shared/types/LimitedOrderingProductRequest";
import type { RetailerType } from "@shared/types/Retailer";

type ProductApprovalStoreType = {
  retailers: RetailerType[];
  productRequests: LimitedOrderingProductRequest[];
};

const initialStore = {
  retailers: [],
  productRequests: [],
};

const ProductApprovalStore = writable<ProductApprovalStoreType>(initialStore);

export default ProductApprovalStore;
